import { Navigate, useLocation } from 'react-router';
import { ReactNode } from 'react';

import { PATH_SETTINGS } from 'domains/userSettings/Routes';
import { isTelegramConfirmationQuery } from 'domains/userSettings/utils/isTelegramConfirmationQuery';

interface ITelegramConfirmationGuardProps {
  children?: ReactNode;
}

export const TelegramConfirmationGuard = ({
  children,
}: ITelegramConfirmationGuardProps) => {
  const location = useLocation();

  const isTelegramConfirmation = isTelegramConfirmationQuery(
    location.search || '',
  );

  if (isTelegramConfirmation) {
    return <>{children}</>;
  }

  return <Navigate to={PATH_SETTINGS} replace />;
};
